module.exports = __webpack_public_path__ + "static/7-224b0b6e3a1d86457a821e3ac7f93057.svg";